/**
 * Created by liux on 2018/2/26.
 * 跳卡贷计算器页
 * @params
 * Object {
 * "type":0,
  "associatedId":"111",
  "associatedProductType":"",
  "associatedScene":"",
  "amount":"100000",
  "period":{
    "periods":12,
    "periods_type":1
  },
    "refreshApplyInfo":1
  }
 * @return boolean
 */
import xyJsBridge from './xyJsBridge'

function openLoanCalcPage(data) {
  return xyJsBridge('jsbridge://www.xiaoying.com/app/operation/openLoanCalcPage', data)
}

export default openLoanCalcPage
